import tailwindConfig from '../../../../../tailwind.config.js';
import resolveConfig from 'tailwindcss/resolveConfig';
import { getProperty } from '@/lego/utils/json/content';

const config = resolveConfig(tailwindConfig);

export function getColor(name) {
    return getProperty(config, `theme.colors.${name}`);
}